import '@/styles/globals.css'
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'flowbite';
import Head from 'next/head';
import Layout from '../components/static/_layout'
import { Cairo } from 'next/font/google'
import { useState } from 'react'
import React from "react";
export const MyContext = React.createContext();

const cairo = Cairo({ subsets: ['arabic'], weight: ['300', '400', '600', '700', '900'] })
const App = ({ Component, pageProps }) => {

const [globalValue, setGlobalValue] = useState(1);
const [isSelected, setIsSelected] = useState(false);
const [priceLöschen, setpriceLöschen] = useState(200);
const [selectedValue, setSelectedValue] = useState(0);


  return (
    <MyContext.Provider value={{ globalValue, setGlobalValue, isSelected, setIsSelected ,priceLöschen , setpriceLöschen, selectedValue, setSelectedValue  }}>
        <Layout className={cairo.className}>
            <style jsx global>{`
            html, body {
            font-family: ${cairo.style.fontFamily};
            direction: rtl;
            }
        `}</style>

        <Head>

            <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
            <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
            <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
            <meta property="og:image" content="https://taliqat123.com/images/global/logo.png" />
            <meta charSet="UTF-8" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://taliqat123.com/" />
            <meta property="og:locale" content="ar_SA" />
            <meta property="og:type" content="article" />
            <meta property="og:url" content="https://taliqat123.com/" />

            </Head>
                <Component {...pageProps} />
        </Layout>
    </MyContext.Provider>
  )
}



export default App